import { lazyModule } from '@servicetitan/lazy-module';
import { FC } from 'react';
import { PageLoading } from '../../page-layout';

const loader = async () => {
    const { PageSearch } = await import(
        /* webpackChunkName: "search" */
        './page-search'
    );

    return PageSearch;
};

const PageSearchLazy = lazyModule({ loader, name: 'Search', loadingComponent: PageLoading });

export const PageSearch: FC = () => <PageSearchLazy />;
